(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-brand-selection-refresh"] && !Shopify.designMode) return;
  try {
    
class BtBrandRefresh extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const cards = [...this.querySelectorAll('[data-brand-card]')];
    const filters = [...this.querySelectorAll('[data-all],[data-filter]')];
    const input = this.querySelector('[data-search]');
    const all = this.querySelector('[data-all]');
    const reset = this.querySelector('[data-reset]');
    const heading = this.querySelector('[data-directory-heading]');
    if (!input || !all || !reset || !heading) return;
    let selected = all;
    const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
    const urlKey = value => {
      try { return new URL(value, window.location.href).pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, ''); }
      catch { return ''; }
    };
    const render = () => {
      const term = normalize(input.value);
      const rows = (selected.dataset.rows || '').split(/\r?\n/).filter(row => row.trim()).map(row => row.split('|'));
      const paths = new Set(rows.map(parts => urlKey((parts[3] || '').trim())).filter(Boolean));
      const names = new Set(rows.map(parts => normalize(parts[0] || '')));
      let count = 0;
      cards.forEach(card => {
        const inGroup = selected === all || paths.has(urlKey(card.getAttribute('href') || '')) || names.has(normalize(card.dataset.name || ''));
        const visible = inGroup && normalize(card.dataset.searchText || '').includes(term);
        card.hidden = !visible;
        if (visible) count++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      this.querySelector('[data-result-label]').textContent = selected.dataset.label || '';
      this.querySelector('[data-count]').textContent = String(count);
      this.querySelector('[data-empty]').hidden = count > 0;
      reset.hidden = selected === all && !term;
    };
    filters.forEach(button => button.addEventListener('click', () => { selected = button; render(); }));
    input.addEventListener('input', render);
    reset.addEventListener('click', () => { selected = all; input.value = ''; render(); input.focus(); });
    this.querySelectorAll('[data-choice]').forEach(button => button.addEventListener('click', () => {
      selected = button;
      input.value = '';
      render();
      heading.focus({ preventScroll: true });
      this.querySelector('.directory').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }));
    this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = false; });
    render();
  }
}
if (!customElements.get('bt-brand-refresh')) customElements.define('bt-brand-refresh', BtBrandRefresh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-cs-contact-v1"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-cs-contact-v1'))customElements.define('bt-cs-contact-v1',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.preview=this.dataset.preview==='true';
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.hasAttribute('data-open-chat'))this.openChat(button);if(button.hasAttribute('data-form-jump'))this.jumpToForm();if(button.dataset.help){const open=button.getAttribute('aria-expanded')!=='true';this.querySelectorAll('[data-help]').forEach(other=>{const active=other===button&&open;other.setAttribute('aria-expanded',String(active));other.querySelector('strong span').textContent=active?'−':'＋';this.querySelector('[data-answer='+other.dataset.help+']').hidden=!active;});}if(button.dataset.category&&!this.category)this.jumpToForm();},options);
this.form=this.querySelector('[data-form]')||this.querySelector('form');if(!this.form)return;this.category=this.querySelector('[data-field=category]');this.editor=this.querySelector('[data-editor]');this.review=this.querySelector('[data-review]');if(!this.category||!this.editor||!this.review)return;this.phase='edit';
this.querySelector('[data-confirm]').textContent=this.dataset.confirmLabel+' →';
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;
if(button.dataset.category){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;this.category.value=button.dataset.category;this.update();const area=this.querySelector('.bt-cs__form-wrap');area.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});this.category.focus({preventScroll:true});}
if(button.hasAttribute('data-edit')){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;this.category.focus();}
if(button.hasAttribute('data-confirm'))this.confirm();
if(this.preview&&button.hasAttribute('data-preview-done')){this.querySelector('[data-preview-feedback]').hidden=false;this.querySelector('[data-preview-feedback]').focus();}
},options);
this.category.addEventListener('change',()=>this.update(),options);
if(!this.preview){this.form.addEventListener('keydown',event=>{if(event.key==='Enter'&&!event.isComposing&&event.keyCode!==229&&this.phase!=='review'&&event.target.tagName==='INPUT'){event.preventDefault();this.confirm();}},options);this.form.addEventListener('submit',event=>{if(this.phase!=='review'||!event.submitter?.hasAttribute('data-send')){event.preventDefault();this.confirm();}},options);}
this.update();
}
update(){const option=this.category.selectedOptions[0],value=this.category.value;this.querySelector('[data-context]').hidden=!value;this.querySelector('[data-context-copy]').textContent=option.dataset.hint||'';this.querySelector('[data-field=message]').placeholder=option.dataset.placeholder||'';const order=this.querySelector('[data-order]'),previous=this.querySelector('[data-previous-email]');order.hidden=!value||value==='other';order.querySelector('input').disabled=order.hidden;previous.hidden=value!=='change';previous.querySelector('input').disabled=previous.hidden;}
confirm(){const controls=Array.from(this.editor.querySelectorAll('input,select,textarea')).filter(el=>!el.disabled),invalid=controls.find(el=>!el.checkValidity());if(invalid){invalid.reportValidity();return;}const list=this.querySelector('[data-review-list]');list.replaceChildren();controls.forEach(control=>{if(!control.value.trim())return;const row=document.createElement('div'),term=document.createElement('dt'),description=document.createElement('dd');term.textContent=control.dataset.reviewLabel;description.textContent=control.tagName==='SELECT'?control.selectedOptions[0].textContent:control.value;row.append(term,description);list.append(row);});this.phase='review';this.editor.hidden=true;this.review.hidden=false;this.querySelector('[data-review-heading]').focus();}

jumpToForm(){if(this.category){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;}this.querySelector('.bt-cs__form-wrap')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});this.category?.focus({preventScroll:true});}
openChat(button){
if(this.chatBusy)return;this.chatBusy=true;this.chatOrigin=button;this.chatObserver?.disconnect();clearTimeout(this.chatTimer);const status=button.closest('[data-chat-entry]').querySelector('[data-chat-status]');status.hidden=false;status.textContent=this.dataset.chatLoading;button.disabled=true;button.setAttribute('aria-busy','true');const started=Date.now();let requested=false,opened=false;
const resetButton=()=>{button.disabled=false;button.removeAttribute('aria-busy');this.chatBusy=false;};
const fail=()=>{clearTimeout(this.chatTimer);this.chatObserver?.disconnect();resetButton();status.textContent=this.dataset.chatUnavailable;status.hidden=false;status.focus();};
const check=()=>{if(!this.isConnected){resetButton();return;}const launcher=document.querySelector('[data-bt-channel-launcher]');if(!requested&&launcher&&!launcher.hidden&&typeof window.ChannelIO==='function'){requested=true;this.chatObserver=new MutationObserver(()=>{if(launcher.classList.contains('is-messenger-open')){opened=true;clearTimeout(this.chatTimer);resetButton();status.hidden=true;document.getElementById('ch-plugin-script-iframe')?.focus();}else if(opened){this.chatObserver?.disconnect();const origin=this.chatOrigin?.isConnected&&this.chatOrigin.getClientRects().length?this.chatOrigin:this.querySelector('.bt-cs__chat [data-open-chat]');origin?.focus({preventScroll:true});}});this.chatObserver.observe(launcher,{attributes:true,attributeFilter:['class']});try{window.ChannelIO('showMessenger');}catch{fail();return;}}
if(launcher?.classList.contains('is-messenger-open')){opened=true;resetButton();status.hidden=true;document.getElementById('ch-plugin-script-iframe')?.focus();return;}if(Date.now()-started>=8000){fail();return;}this.chatTimer=setTimeout(check,200);};check();
}
disconnectedCallback(){clearTimeout(this.chatTimer);this.chatObserver?.disconnect();this.chatBusy=false;if(this.chatOrigin){this.chatOrigin.disabled=false;this.chatOrigin.removeAttribute("aria-busy");}this.querySelectorAll("[data-chat-status]").forEach(status=>status.hidden=true);this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-feature-editorial-v1"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('bt-feature-editorial'))customElements.define('bt-feature-editorial',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.items=[...this.querySelectorAll('[data-card]')];this.buttons=[...this.querySelectorAll('[data-filter]')];if(!this.buttons.length)return;
      const requested=new URL(location.href).searchParams.get('category');this.active=this.buttons.some(b=>b.dataset.filter===requested)?requested:'featured';
      this.querySelector('[data-filters]').hidden=false;this.querySelector('[data-selection]').hidden=false;
      this.onClick=e=>{const button=e.target.closest('[data-filter]');if(!button||!this.contains(button))return;this.active=button.dataset.filter;this.apply();const url=new URL(location.href);url.searchParams.set('category',this.active);history.replaceState(null,'',url);};
      this.addEventListener('click',this.onClick);this.apply();
    }
    apply(){
      clearTimeout(this.timer);const now=Date.now();const available=this.items.filter(item=>!item.dataset.end||Date.parse(item.dataset.end)>now);const matches=(item,category)=>category==='featured'?item.dataset.featured==='true':item.dataset.category===category;
      this.dataset.active=this.active;this.buttons.forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.filter===this.active));button.querySelector('[data-filter-count]').textContent=available.filter(item=>matches(item,button.dataset.filter)).length;});
      this.items.forEach(item=>{item.hidden=!available.includes(item)||!matches(item,this.active);});const selected=this.buttons.find(button=>button.dataset.filter===this.active);this.querySelector('[data-selection-label]').textContent=selected.querySelector('span').textContent;this.querySelector('[data-selection-count]').textContent=available.filter(item=>matches(item,this.active)).length+this.dataset.unit;
      const future=available.map(item=>Date.parse(item.dataset.end)).filter(time=>Number.isFinite(time)&&time>now);if(future.length)this.timer=setTimeout(()=>this.apply(),Math.min(Math.min(...future)-now+100,2147483000));
    }
    disconnectedCallback(){clearTimeout(this.timer);this.removeEventListener('click',this.onClick);this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-gift-editorial-v1-entry"]) return;
  try {
    
customElements.define('bt-gift-entry-v1',class extends HTMLElement{
  connectedCallback(){
    if(this.started)return;
    this.started=true;
    const href=this.dataset.giftUrl;
    const addEntry=()=>{
      const desktop=document.querySelector('#BtNavigationV1 .nav-items');
      if(desktop&&!desktop.querySelector('.bt-gift-desktop-entry')){
        const a=document.createElement('a');a.href=href;a.className='bt-gift-desktop-entry';a.textContent='ギフト';desktop.insertBefore(a,desktop.querySelector('[data-mega="features"]'));
      }
      const body=document.querySelector('#BtNavBody');
      const quick=body?.querySelector('.quick-links');
      if(quick&&body.querySelector('.category-list')&&!body.querySelector('.bt-gift-mobile-entry')){
        const a=document.createElement('a');a.href=href;a.className='bt-gift-mobile-entry';a.innerHTML='<strong>ギフトを探す</strong><small>予算から選ぶ・相手に選んでもらう</small><span aria-hidden="true">↗</span>';quick.after(a);
      }
    };
    addEntry();
    const nav=document.querySelector('#BtNavigationV1');
    if(nav){this.navObserver=new MutationObserver(addEntry);this.navObserver.observe(nav,{childList:true,subtree:true});}
    if(this.dataset.page!=='product')return;
    const main=document.querySelector('#MainContent');
    if(!main)return;
    const setupGift=()=>{
      const button=main.querySelector('.anygift-e-gift-modal__open-button');
      const ui=button?.closest('.anygift-e-gift-modal__ui');
      if(!button||!ui)return;
      ui.classList.add('bt-gift-pdp-ui');
      const course=this.dataset.selectable==='true';
      const label=course?'このコースをeギフトで贈る':'この商品をLINE・メールで贈る';
      if(button.textContent!==label)button.textContent=label;
      if(course){main.classList.add('bt-gift-course-ready');for(const checkout of main.querySelectorAll('.shopify-payment-button')){checkout.setAttribute('inert','');checkout.setAttribute('aria-hidden','true');}}
      if(!main.querySelector('.bt-gift-pdp-note')){
        const note=document.createElement('div');note.className='bt-gift-pdp-note';
        const p=document.createElement('p');p.textContent=course?'贈る方はコースを選ぶだけ。受け取る方が、対象商品・カラー・対応サイズ・配送先を選びます。':'この商品のeギフトでは、贈る方がカラー・対応サイズを選びます。サイズや好みが分からない場合は、選べるeギフトもあります。';
        const a=document.createElement('a');a.href=href;a.textContent='選べるeギフト・贈り方を見る ↗';note.append(p,a);ui.after(note);
      }
    };
    setupGift();this.giftObserver=new MutationObserver(setupGift);this.giftObserver.observe(main.querySelector('.buy-buttons-block')||main,{childList:true,subtree:true});
  }
  disconnectedCallback(){this.navObserver?.disconnect();this.giftObserver?.disconnect();this.started=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-gift-editorial-v1"]) return;
  try {
    
customElements.define('bt-gift-editorial-v1',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const root=this;const data=JSON.parse(root.querySelector('[data-gift-data]').textContent);
  const money = n => n.toLocaleString('ja-JP');
  const escape = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let budget = 'all';
  function renderProducts(){
    const list=Object.values(data.editorialProducts).filter(p=>budget==='all'||(budget==='under5000'&&p.price<5000)||(budget==='under10000'&&p.price>=5000&&p.price<10000)||(budget==='over10000'&&p.price>=10000));
    root.querySelector('[id^="BtGiftV1-products-"]').innerHTML=list.map(p=>`<article class="product-card"><a href="${escape(p.href)}" ><img src="${escape(p.image)}" alt="${escape(p.title)}" width="600" height="600" loading="lazy"><h3>${escape(p.title)}</h3><p class="price">¥${money(p.price)} <small>（税込）</small></p></a></article>`).join('');
    root.querySelector('[id^="BtGiftV1-product-count-"]').textContent=`${list.length}件の掲載例`;
  }
  renderProducts();
  const productCard = key => {
    const p = data.editorialProducts[key];
    return `<article class="product-card"><a href="${escape(p.href)}" ><img src="${escape(p.image)}" alt="${escape(p.title)}" width="600" height="600" loading="lazy"><h3>${escape(p.title)}</h3><p class="price">¥${money(p.price)} <small>（税込）</small></p></a></article>`;
  };
  function selectTab(attribute, value, panel){
    root.querySelectorAll(`[${attribute}]`).forEach(b=>{const selected=b.getAttribute(attribute)===String(value);b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;if(selected)root.querySelector(panel).setAttribute('aria-labelledby',b.id);});
  }
  function wireTabs(attribute, render){
    const buttons=[...root.querySelectorAll(`[${attribute}]`)];
    buttons.forEach((b,i)=>{
      b.addEventListener('click',()=>render(b.getAttribute(attribute)));
      b.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();
        const next=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
        render(buttons[next].getAttribute(attribute));buttons[next].focus();
      });
    });
  }
  function renderCourse(price){
    const c=data.courses.find(c=>c.price===Number(price));
    selectTab('data-course',price,'[id^="BtGiftV1-catalogue-panel-"]');
    root.querySelector('[id^="BtGiftV1-catalogue-heading-"]').textContent=c.title+'の対象商品例';
    root.querySelector('[id^="BtGiftV1-catalogue-description-"]').textContent=c.description;
    root.querySelector('[id^="BtGiftV1-catalogue-products-"]').innerHTML=c.examples.map(p=>`<article class="catalogue-card"><img src="${escape(p.image)}" alt="${escape(p.title)}" width="600" height="600" loading="lazy"><h4>${escape(p.title)}</h4><p>${money(c.price)}円コースの対象</p></article>`).join('');
    const a=root.querySelector('[id^="BtGiftV1-catalogue-link-"]');a.href=c.href;a.innerHTML=`${money(c.price)}円コースを詳しく見る <span aria-hidden="true">↗</span>`;
  }
  wireTabs('data-course',renderCourse);renderCourse(5000);
  root.querySelectorAll('[data-inspect-course]').forEach(a=>a.addEventListener('click',()=>renderCourse(a.dataset.inspectCourse)));
  function renderScene(key){
    const s=data.scenes[key];selectTab('data-scene',key,'[id^="BtGiftV1-scene-panel-"]');
    root.querySelector('[id^="BtGiftV1-scene-kicker-"]').textContent=s.kicker;
    root.querySelector('[id^="BtGiftV1-scene-title-"]').textContent=s.title;
    root.querySelector('[id^="BtGiftV1-scene-body-"]').textContent=s.body;
    const a=root.querySelector('[id^="BtGiftV1-scene-course-"]');a.href='#BtGiftV1-catalogue-'+root.dataset.section;a.textContent=s.link+' ↓';a.removeAttribute('data-method');a.onclick=()=>renderCourse(s.course);
    root.querySelector('[id^="BtGiftV1-scene-products-"]').innerHTML=s.products.map(productCard).join('');
  }
  wireTabs('data-scene',renderScene);renderScene('birthday');
  function renderStyle(key){
    const s=data.styles[key];selectTab('data-style',key,'[id^="BtGiftV1-style-panel-"]');
    root.querySelector('[id^="BtGiftV1-style-caption-"]').textContent=s.caption;
    root.querySelector('[id^="BtGiftV1-style-products-"]').innerHTML=s.products.map(productCard).join('');
  }
  wireTabs('data-style',renderStyle);renderStyle('work');
  root.querySelector('[id^="BtGiftV1-gift-brands-"]').innerHTML=data.brands.map(b=>`<article class="brand-card"><a href="${escape(b.href)}" ><img src="${escape(b.image)}" alt="${escape(b.title)}のバンド" width="800" height="600" loading="lazy"><div><h3>${escape(b.title)}</h3><p>${escape(b.description)}</p><span>このブランドを見る ↗</span></div></a></article>`).join('');
  function renderHow(key){
    selectTab('data-how',key,'[id^="BtGiftV1-how-panel-"]');
    root.querySelector('[id^="BtGiftV1-how-list-"]').innerHTML=data.how[key].map((s,i)=>`<li><span>0${i+1}</span><div><h3>${escape(s.title)}</h3><p>${escape(s.body)}</p></div></li>`).join('');
  }
  wireTabs('data-how',renderHow);renderHow('send');
  function setMethod(method){
    root.querySelectorAll('[data-method-tab]').forEach(b=>{const selected=b.dataset.methodTab===method;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;});
    root.querySelector('[id^="BtGiftV1-egift-panel-"]').hidden=method!=='egift';
    root.querySelector('[id^="BtGiftV1-direct-panel-"]').hidden=method!=='direct';
  }
  root.querySelectorAll('[data-method-tab]').forEach(b=>{
    b.addEventListener('click',()=>setMethod(b.dataset.methodTab));
    b.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const m=e.key==='Home'?'egift':e.key==='End'?'direct':b.dataset.methodTab==='egift'?'direct':'egift';setMethod(m);root.querySelector(`[data-method-tab="${m}"]`).focus();}});
  });
  root.querySelectorAll('[data-method]').forEach(a=>a.addEventListener('click',()=>{
    setMethod(a.dataset.method);
    if(a.dataset.occasion)root.querySelector('[id^="BtGiftV1-choose-title-"]').textContent=a.dataset.occasion+'の贈りものを、予算から。';
  }));
  root.querySelectorAll('[data-budget]').forEach(b=>b.addEventListener('click',()=>{budget=b.dataset.budget;root.querySelectorAll('[data-budget]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));renderProducts();}));

}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-home-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let timer;
    const refreshHalloweenBanners = () => {
      let nextEnd = Infinity;
      document.querySelectorAll('[data-bt-hw26-ends-at]').forEach((banner) => {
        const end = Date.parse(banner.dataset.btHw26EndsAt);
        const ended = banner.dataset.btHw26Closed === 'true' || Date.now() >= end;
        const live = banner.querySelector('.bt-home-banners__hw26-live');
        const closed = banner.querySelector('.bt-home-banners__hw26-ended');
        if (!live || !closed || !Number.isFinite(end)) return;
        live.hidden = ended;
        closed.hidden = !ended;
        if (!ended) nextEnd = Math.min(nextEnd, end);
      });
      clearTimeout(timer);
      if (Number.isFinite(nextEnd)) timer = setTimeout(refreshHalloweenBanners, Math.min(Math.max(nextEnd - Date.now(), 0) + 50, 2147483647));
    };
    refreshHalloweenBanners();
    document.addEventListener('DOMContentLoaded', refreshHalloweenBanners, { once: true });
    document.addEventListener('shopify:section:load', refreshHalloweenBanners);
    document.addEventListener('visibilitychange', refreshHalloweenBanners);
    window.addEventListener('pageshow', refreshHalloweenBanners);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-home-slides-v10"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-home-slides-v10')) {
    customElements.define('bt-home-slides-v10', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-pause]');
        this.current = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.suppressClick = false;
        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }
          const control = event.target.closest('button');
          if (!control) return;
          if (control.hasAttribute('data-dot')) this.show(Number(control.dataset.dot), true);
          else if (control.hasAttribute('data-step')) this.show(this.current + Number(control.dataset.step), true);
          else if (control.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            control.setAttribute('aria-pressed', String(this.paused));
            control.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
            control.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
            this.restart();
          }
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || event.target.closest('button')) return;
          this.pointer = { x: event.clientX, y: event.clientY };
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.pointer) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            this.suppressClick = true;
            this.show(this.current + (dx < 0 ? 1 : -1), true);
            clearTimeout(this.swipeTimer);
            this.swipeTimer = setTimeout(() => { this.suppressClick = false; }, 400);
          }
        }, options);
        this.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); if (!this.focused) this.start(); }, options);
        document.addEventListener('visibilitychange', () => { this.refreshHalloween(); this.restart(); }, options);
        window.addEventListener('pageshow', () => { this.refreshHalloween(); }, options);
        window.addEventListener('resize', () => { this.restart(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editing = true; this.stop(); this.show(index); }
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) { this.editing = false; this.start(); }
        }, options);
        this.refreshHalloween(); this.show(0); this.start();
      }
      disconnectedCallback() { this.stop(); clearTimeout(this.swipeTimer); clearTimeout(this.halloweenTimer); this.abort?.abort(); }
      refreshHalloween() {
        clearTimeout(this.halloweenTimer);
        let nextEnd = Infinity;
        this.querySelectorAll('[data-hw26-ends-at]').forEach(slide => {
          const end = Date.parse(slide.dataset.hw26EndsAt);
          const ended = slide.dataset.hw26Closed === 'true' || Date.now() >= end;
          slide.querySelector('.bt-top10__hw-live').hidden = ended;
          slide.querySelector('.bt-top10__hw-ended').hidden = !ended;
          if (!ended) nextEnd = Math.min(nextEnd,end);
        });
        if (Number.isFinite(nextEnd)) this.halloweenTimer = setTimeout(() => this.refreshHalloween(), Math.min(Math.max(nextEnd-Date.now()+50,50),2147483647));
      }
      show(index, restart = false) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { const active = i === this.current; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.current)));
        if (restart) this.restart();
      }
      restart() { this.stop(); this.start(); }
      start() {
        const seconds = Number(this.dataset.autoplaySeconds || 0);
        if (this.timer || seconds <= 0 || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editing || document.hidden || matchMedia('(max-width:767px), (prefers-reduced-motion:reduce)').matches) return;
        this.timer = setInterval(() => this.show(this.current + 1), seconds * 1000);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-series12-case-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const filters = root.querySelector('[data-filters]');
      const empty = root.querySelector('[data-empty]');
      const status = root.querySelector('[data-filter-status]');
      const countSuffix = root.querySelector('[data-count-suffix]').textContent;
      const state = { size: 'all', type: 'all' };
      const render = () => {
        let count = 0;
        cards.forEach((card) => {
          const suffix = state.size === 'all' ? 'default' : state.size;
          const url = suffix === 'default' ? card.dataset.defaultUrl : card.getAttribute(`data-url-${suffix}`);
          const price = suffix === 'default' ? card.dataset.defaultPrice : card.getAttribute(`data-price-${suffix}`);
          const available = suffix === 'default' ? card.dataset.defaultAvailable : card.getAttribute(`data-available-${suffix}`);
          const matchesType = state.type === 'all' || card.dataset.productType === state.type;
          card.hidden = !matchesType || !url;
          if (!card.hidden) count += 1;
          card.querySelectorAll('[data-product-link]').forEach((link) => {
            if (url) link.setAttribute('href', url);
            else link.removeAttribute('href');
          });
          card.querySelector('[data-card-price]').textContent = price || card.dataset.defaultPrice;
          card.querySelector('[data-card-stock]').hidden = available === 'true';
          card.querySelectorAll('[data-card-size]').forEach((link) => {
            if (link.dataset.cardSize === state.size) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        });
        root.querySelectorAll('[data-size]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.size === state.size)));
        root.querySelectorAll('[data-type]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.type === state.type)));
        empty.hidden = count > 0;
        status.textContent = `${count}${countSuffix}`;
      };
      filters.hidden = false;
      root.addEventListener('click', (event) => {
        const target = event.target.closest('[data-size], [data-type], [data-size-jump], [data-type-jump]');
        if (!target || !root.contains(target)) return;
        if (target.hasAttribute('data-size')) state.size = target.dataset.size;
        if (target.hasAttribute('data-type')) state.type = target.dataset.type;
        if (target.hasAttribute('data-size-jump')) { state.size = target.dataset.sizeJump; state.type = 'all'; }
        if (target.hasAttribute('data-type-jump')) { state.type = target.dataset.typeJump; state.size = 'all'; }
        render();
      });
      render();
    };
    document.querySelectorAll('[data-series12-feature]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-series12-feature]');
      if (root) initialise(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt_cs_chronos_guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#bt-cs-chronos-guide [data-bt-chronos-chat]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.ChannelIO !== 'function') return;
    try {
      window.ChannelIO('showMessenger');
      event.preventDefault();
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt_cs_sirius_guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#bt-cs-sirius-guide [data-bt-sirius-chat]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.ChannelIO !== 'function') return;
    try {
      window.ChannelIO('showMessenger');
      event.preventDefault();
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuntom-category-links"] && !Shopify.designMode) return;
  try {
    
/* 必要なJavaScriptをここに追加 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
